module.exports = __webpack_public_path__ + "static/media/cs.926286b7.jpg";